// Event Bus for cross-component communication
type EventCallback = (...args: any[]) => void;

class EventBus {
  private events: Map<string, EventCallback[]> = new Map();

  // Subscribe to an event
  on(event: string, callback: EventCallback): () => void {
    if (!this.events.has(event)) {
      this.events.set(event, []);
    }

    const callbacks = this.events.get(event)!;
    callbacks.push(callback);

    // Return unsubscribe function
    return () => {
      const index = callbacks.indexOf(callback);
      if (index > -1) {
        callbacks.splice(index, 1);
      }
    };
  }

  // Emit an event
  emit(event: string, ...args: any[]): void {
    const callbacks = this.events.get(event);
    if (callbacks) {
      callbacks.forEach((callback) => {
        try {
          callback(...args);
        } catch (error) {
          console.error(`Error in event handler for '${event}':`, error);
        }
      });
    }
  }

  // Remove all listeners for an event
  off(event: string): void {
    this.events.delete(event);
  }

  // Clear all events
  clear(): void {
    this.events.clear();
  }
}

// Create singleton instance
export const eventBus = new EventBus();

// Event names as constants to avoid typos
export const EVENTS = {
  EMAILS_FETCHED: 'emails:fetched',
  SALES_CREATED_FROM_EMAIL: 'sales:created-from-email',
  REFRESH_SALES: 'sales:refresh',
  REFRESH_TICKETS: 'tickets:refresh',
  REFRESH_EVENTS: 'events:refresh',
  SALES_FULFILLED: 'sales:fulfilled',
  EMAIL_FETCH_COMPLETE: 'email:fetch-complete',
  SALE_UPDATED: 'sale:updated',
} as const;
